<template>
  <modal-form v-model="show" size="lg"
    :show-submit="false" text-close="Fechar"
    body-class="pa-0"
  >
    <template slot="title">
      Resumo da Simulação
    </template>
    <template slot="body">
      <v-card flat>
        <v-card-text>
          <SimulacaoResumo ref="infos" :value="model" />
        </v-card-text>
      </v-card>
    </template>
  </modal-form>
</template>

<script>
export default {
  components: {
    SimulacaoResumo: () => import('./SimulacaoResumo.vue'),
  },
  data () {
    return {
      show: false,
      model: {},
    };
  },
  methods: {
    openModal (sender) {
      const th = this
      th.$api.Simulacao.Get(sender.codigo).then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$set(th, 'model', JSON.parse(response.modelJson))
          th.$set(th.model, 'Codigo', response.codigo)
          th.$set(th.model, 'CodigoEmpresa', response.codigoEmpresa)
          th.$set(th.model, 'CodigoUsuario', response.codigoUsuario)
          th.$set(th.model, 'Descricao', response.descricao)
          th.$set(th.model, 'DtExpiracao', response.dtExpiracao.toString().split('T')[0])
          th.$set(th.model, 'Id', response.id)
          th.$set(th.model, 'IsValid', response.isValid)
          th.$set(th.model, 'Nome', response.nome)
          th.$set(th.model, 'TipoRegistro', response.tiporegistro)
          th.$set(th.model, 'metodoEnvio', null)
          th.$set(th.model, 'email', null)
          th.$set(th.model, 'opcaoSelecionada', null)
          th.show = true
          th.load(sender)
        }
      })
    },
    load (sender) {
      const th = this

      setTimeout(() => {
        if (th.$refs.infos) {
          th.$refs.infos.load(sender)
        } else {
          th.load(sender)
        }
      }, 10)
    }
  },
};
</script>
